module.exports = __webpack_public_path__ + "img/00032.86e31ae5.webp";